import apiClient from "./client";
import type { IdParam } from "../types/common";
import type {
  UserCreateUpdatePayload,
  UserGetResponse,
  UserMutationResponse,
} from "../types/user";

export const getUser = async (userId: IdParam): Promise<UserGetResponse> => {
  const { data } = await apiClient.get<UserGetResponse>(`/user/${userId}`);
  return data;
};

export const createUser = async (
  data: UserCreateUpdatePayload
): Promise<UserMutationResponse> => {
  const { data: response } = await apiClient.post<UserMutationResponse>(
    "/user",
    data
  );
  return response;
};

export const updateUser = async (
  userId: IdParam,
  data: UserCreateUpdatePayload
): Promise<UserMutationResponse> => {
  const { data: response } = await apiClient.put<UserMutationResponse>(
    `/user/${userId}`,
    data
  );
  return response;
};

export const deleteUser = async (
  userId: IdParam
): Promise<UserMutationResponse> => {
  const { data } = await apiClient.delete<UserMutationResponse>(
    `/user/${userId}`
  );
  return data;
};
